// @flow
import type { Dispatch, GetState } from 'state/types';
import {
  getIdentitySession,
  getRoles as getRolesSelector,
} from 'state/selectors';
import { actions as roleActions } from 'state/reducers/roleReducer';
import { actions as modalPromptActions } from 'portfolio-shared/state/reducers/modalPromptReducer';
import type { Role } from 'state/types';
import localizedStrings from 'util/localizedStrings';

const {
  createRole: createRoleAction,
  deleteRole: deleteRoleAction,
  getRoles: getRolesAction,
  setSelectedRole: setSelectedRoleAction,
  updateRole: updateRoleAction,
} = roleActions;
const { showModalPrompt } = modalPromptActions;

export function getRoles() {
  return async function getRoles(dispatch: Dispatch, getState: GetState) {
    const session = getIdentitySession(getState());
    if (session) {
      await dispatch(getRolesAction(session));
    }
  };
}

function _findRole(roleName: string, roles: Role[]): ?Role {
  return roles.find(role => role.name === roleName);
}

export function createRole(roleName: string) {
  return async function createRole(dispatch: Dispatch, getState: GetState) {
    const session = getIdentitySession(getState());
    if (session) {
      await dispatch(createRoleAction(session, roleName));
      await dispatch(getRolesAction(session));
      const roleToSelect: ?Role = _findRole(
        roleName,
        getRolesSelector(getState())
      );
      if (roleToSelect) {
        await dispatch(setSelectedRole(roleToSelect));
      }
    }
  };
}

export function deleteRole(roleName: string) {
  return async function deleteRole(dispatch: Dispatch, getState: GetState) {
    const session = getIdentitySession(getState());
    if (session) {
      await dispatch(
        showModalPrompt({
          isButton2Default: true,
          message: localizedStrings.ROLES_DELETE_CONFIRM,
          dataTestName: 'delete-role-modal',
          onButton2: async function doDelete() {
            await dispatch(deleteRoleAction(session, roleName));
            await dispatch(getRolesAction(session));
            const roleToSelect: ?Role = _findRole(
              'Reader',
              getRolesSelector(getState())
            );
            if (roleToSelect) {
              await dispatch(setSelectedRole(roleToSelect));
            }
          },
        })
      );
    }
  };
}

export function updateRole(roleName: string, grant: string, revoke: string) {
  return async function updateRole(dispatch: Dispatch, getState: GetState) {
    const session = getIdentitySession(getState());
    if (session) {
      await dispatch(updateRoleAction(session, roleName, grant, revoke));
      await dispatch(getRolesAction(session));
    }
  };
}

export function setSelectedRole(role: Role) {
  return async function setSelectedRole(
    dispatch: Dispatch,
    getState: GetState
  ) {
    await dispatch(setSelectedRoleAction(role));
  };
}



// WEBPACK FOOTER //
// ./src/state/commands/roleCommands.js